import React from "react";
import { Routes, Route } from "react-router-dom";

import App from '../App'
import SsoRedirectHandler from "../views/ssoredirecthandler";
//import Dashboard from "../modules/dashboard/views/indexold";
import Login from "../modules/login/views/Login"
import RecoverPassword from "../modules/login/views/RecoverPassword";
import RecoverPasswordSuccess from "../modules/login/views/RecoverPasswordSuccess";
import ResetForgotPassword from "../modules/login/views/ResetForgotPassword";
import ResetForgotPasswordSuccess from "../modules/login/views/ResetPasswordSuccess";
import Dashboard from "../modules/dashboard/views";

import UserProfile from "../modules/userprofile/views/userprofile"
import MicrosoftLoginHandler from "../views/microsoftloginhandler";
//admin
import DashboardConfiguration from '../modules/admin/views/dashboardconfiguration'

import UserMainScreen from '../modules/secmaster/views/usermainscreen' 
import UserGroup from "../modules/secmaster/views/usergroup";
import UserGroupMenus from "../modules/secmaster/views/usergroupmenus";
import PasswordProfile from "../modules/secmaster/views/passwordprofile";
import GroupMenus from "../modules/secmaster/views/groupmenus";
var routes = (
  <App>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/dashboard" element={<Dashboard  />} />
      <Route path="/userprofile" element={<UserProfile />} />
     
      <Route path="/recoverpassword" element={<RecoverPassword />} />
      <Route path="/recoverpasswordsuccess" element={<RecoverPasswordSuccess />} />
      <Route path="/resetforgotpassword" element={<ResetForgotPassword />} />
      <Route path="/resetforgotpasswordsuccess" element={<ResetForgotPasswordSuccess />} />
      <Route path="/handlemicrosoftlogin" element={<MicrosoftLoginHandler />} />

      <Route path="/dashboardconfiguration" element={<DashboardConfiguration />} />

      <Route path="/usersearch" element={<UserMainScreen />} /> 

      <Route path="/ssoredirecthandler" element={<SsoRedirectHandler />} /> 

      <Route path="/groupsearch" element={<UserGroup />} /> 
      <Route path="/usergroups" element={<UserGroupMenus />} /> 
      <Route path="/passwordprofile" element={<PasswordProfile />} /> 
      <Route path="/groupmenus" element={<GroupMenus />} /> 

    </Routes>
  </App>
);

export default routes;
